namespace Seac.Commons {
	export interface Notification {
		message				: string;
		title?				: string;
		onClick				: () => void;
		notificationType	: NotificationType;
	}

	export enum NotificationType {
		info	= 1,
		success = 2,
		warning = 3,
		error	= 4,
	}
}
